window.VH = window.VH === undefined ? {} : window.VH;
VH.FileWidget = {
    afterDelete : function afterDelete(event, element, result)
    {
        element.closest('.utx-file').remove();
        // console.log([event, element, $(this)]);
    },

    formatBytes : function formatBytes(bytes, decimals = 2) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        if (bytes === 0) {
            return '0 ' + sizes[0];
        }

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },

    getFileElement : function getFileElement(file) {
        let _t = VH.FileWidget,
            title = file.name + ' (' + _t.formatBytes(file.size) + ')',
            s = '<div class="col-12 col-lg-6 col-xl-4 my-2 utx-file utx-file-new">';
        s += '<div class="btn-group btn-group-sm shadow-sm w-100">';

        s += '<span class="btn btn-block btn-outline-info text-left utx-file-title" title="' + title + '">' +
            '<i class="fas fa-file-upload"></i>&nbsp;' +
            title +
            '</span>';
        // s += '<button type="button" class="btn btn-outline-warning">' +
        //     '<i class="fas fa-trash-alt"></i>' +
        //     '</button>';
        s += '</div></div>';

        return s;
    },

    afterChange : function afterChange(event)
    {
        let _t = VH.FileWidget,
            t = $(this),
            inform = t.closest('.input-group').find('.utx-file-upload-info'),
            files = t[0].files,
            listContainer = t.closest('.utx-file-upload').find('.utx-file-list')
        ;

        inform.val('Выбрано файлов: ' + files.length);

        listContainer.find('.utx-file-new').remove();
        for (let i = 0; i < files.length; i++) {
            listContainer.append($(_t.getFileElement(files[i])));
        }

        console.log([t, event]);
    },

    afterCancel : function afterCancel(event)
    {
        let _t = VH.FileWidget,
            t = $(this),
            input = t.closest('.input-group').find('[type="file"]');
        input.val('');
        input.trigger('change');
        console.log([t, event, input]);
    },

    init: function init() {
        let _t = VH.FileWidget,
            widgets = $('.utx-file-upload');
        widgets.on('change', '[type="file"]', _t.afterChange);
        widgets.on('click', '.utx-file-upload-cancel', _t.afterCancel);
    }
};
